/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Text } from '@doveit/bricks';
import GenericPageLayoutContext from '../GenericPageLayoutContext';
import GenericPageLayoutWrapper, { GenericPageLayoutWrapperSize } from '../wrapper/GenericPageLayoutWrapper';
import * as styles from './GenericPageLayoutContent.style';

export type GenericPageLayoutContentProps = React.PropsWithChildren<{
  innerRef?: React.RefObject<HTMLDivElement>,
  wrapperSize?: GenericPageLayoutWrapperSize,
  title?: React.ReactNode,
  subtitle?: React.ReactNode,
  headerSlot?: React.ReactNode,
  fitMaxAvailableHeight?: boolean,
}>;

const GenericPageLayoutContent: React.FC<GenericPageLayoutContentProps> = ({
  innerRef,
  wrapperSize,
  title,
  subtitle,
  headerSlot,
  children,
  fitMaxAvailableHeight,
}) => {
  const context = React.useContext(GenericPageLayoutContext);
  const { wrapperSize: contextMaxWrapperWidth } = context;

  return (
    <div
      css={styles.content}
      $fitMaxAvailableHeight={fitMaxAvailableHeight}
      data-ref="generic-page-layout-content"
    >
      <main
        css={styles.main}
        ref={innerRef}
      >
        <GenericPageLayoutWrapper
          maxWidth={wrapperSize || contextMaxWrapperWidth}
          fitMaxAvailableHeight={fitMaxAvailableHeight}
        >
          <div
            css={styles.mainContent}
            $fitMaxAvailableHeight={fitMaxAvailableHeight}
          >
            {(title || subtitle || headerSlot) && (
              <div css={styles.header}>
                <div css={styles.headerContent}>
                  <div css={styles.headerPrimary}>
                    {title && (
                      <Text.H3 as="h1">
                        {title}
                      </Text.H3>
                    )}
                    {subtitle && (
                      <div
                        data-ref="generic-page-layout-subtitle"
                        css={styles.subtitle}
                      >
                        {subtitle}
                      </div>
                    )}
                  </div>
                  {headerSlot && (
                    <div css={styles.headerSecondary}>
                      {headerSlot}
                    </div>
                  )}
                </div>
              </div>
            )}
            {children}
          </div>
        </GenericPageLayoutWrapper>
      </main>
    </div>
  );
};

export default GenericPageLayoutContent;
